import {getLocalStorage} from '../../util/LocalStorage'
import {CP_PANEL_INITIAL_WIDTH, TM_CP_PANEL_COLLAPSED_CUSTOMERS_SET_LS_KEY, TM_CP_PANEL_WIDTH_LS_KEY} from './constants'

export const saveCPPanelWidthToLocalStorage = (width) => {
    getLocalStorage().setItem(TM_CP_PANEL_WIDTH_LS_KEY, width)
}

export const loadCpPanelWidthFromLocalStorage = () => {
    const cpBlockWidth = getLocalStorage().getItem(TM_CP_PANEL_WIDTH_LS_KEY)
    return cpBlockWidth ? cpBlockWidth : CP_PANEL_INITIAL_WIDTH;
}

export const saveCPPanelCollapsedCustomersToLocalStorage = (collapsedCustomersSet) => {
    getLocalStorage().setItem(TM_CP_PANEL_COLLAPSED_CUSTOMERS_SET_LS_KEY, collapsedCustomersSet)
}

export const loadCPPanelCollapsedCustomersFromLocalStorage = () => {
    return getLocalStorage().getItem(TM_CP_PANEL_COLLAPSED_CUSTOMERS_SET_LS_KEY)
}




// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/utils.js